import React from 'react';
import { Box, Card, CardContent, IconButton, Typography } from '@mui/material';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { Close } from '@mui/icons-material';
import { IMetadataLogin } from '../../Interfaces/IMetadataLogin';

export interface IChartData {
  name: string;
  value: number;
}

interface IProps {
  keyName: string;
  metadataLoginArray: IMetadataLogin[];
  activeDashboard: string[];
  setActiveDashboard: Function;
}

export const PieChartOS: React.FC<IProps> = ({
  keyName,
  metadataLoginArray,
  activeDashboard,
  setActiveDashboard,
}) => {
  const uniqueOs = Array.from(
    new Set(metadataLoginArray.map(login => login.OS))
  );

  const COLORS = [
    '#39ff14', // Neon grün
    '#ff073a', // Neon rot
    '#0afff0', // Neon blau
    '#ff7aff', // Neon pink
    '#fffb00', // Neon gelb
  ];

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = (props: any) => {
    const radius =
      Number(props['innerRadius']) +
      (Number(props['outerRadius']) - Number(props['innerRadius'])) * 0.5;
    const x =
      Number(props['cx']) +
      radius * Math.cos(-Number(props['midAngle']) * RADIAN);
    const y =
      Number(props['cy']) +
      radius * Math.sin(-Number(props['midAngle']) * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill='white'
        textAnchor={x > Number(props['cx']) ? 'start' : 'end'}
        dominantBaseline='central'
      >
        {`${(Number(props['percent']) * 100).toFixed(0)}%`}
      </text>
    );
  };

  const chartData = () => {
    const returnArray: IChartData[] = [];
    uniqueOs.map(x =>
      returnArray.push({
        name: x,
        value: metadataLoginArray.filter(login => login.OS === x).length,
      })
    );
    return returnArray;
  };

  const onRemove = () => {
    setActiveDashboard([...activeDashboard.filter(x => x !== keyName)]);
  };

  return (
    <Card variant='outlined'>
      <IconButton sx={{ float: 'right' }} onClick={onRemove}>
        <Close sx={{ fontSize: 14 }} />
      </IconButton>
      <CardContent>
        <Box sx={{ display: 'flex' }}>
          <Typography>Betriebssystemverteilung</Typography>
        </Box>
        <Box
          sx={{
            height: { xs: 150, sm: 250, xl: 300 },
            mt: 2,
            minWidth: 300,
            width: '100%',
          }}
        >
          <ResponsiveContainer width='100%' height='100%'>
            <PieChart>
              <Pie
                data={chartData()}
                cx='50%'
                cy='45%' // etwas höher setzen, um Platz für Legende unten zu schaffen
                labelLine={false}
                outerRadius='80%'
                fill='#4cb1ad'
                dataKey='value'
                label={renderCustomizedLabel}
              >
                {chartData().map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Legend
                layout='horizontal'
                verticalAlign='bottom'
                align='center'
              />
            </PieChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Card>
  );
};
